import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { ROUTESPATH } from '@core';
import { ModalService } from '@avla/ui-design';
import { TokenService } from '@services';

@Component({
  selector: 'app-modal-close-session',
  templateUrl: './modal-close-session.component.html',
  styleUrls: ['./modal-close-session.component.scss'],
})
export class ModalCloseSessionComponent {
  modalName = 'modal-close-session';

  constructor(
    private modalService: ModalService,
    private router: Router,
    private readonly tokenService: TokenService
  ) {}

  closeModal() {
    this.modalService.close(this.modalName);
  }

  closeSession() {
    this.tokenService.resetToken();
    this.router.navigate([ROUTESPATH.LOGIN]);
    this.modalService.close(this.modalName);
  }
}
